import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { KanbanBoard } from "../../common/KanbanBoard/index.jsx";
import axiosInstance from "../../api/axiosInstance.js";
import { MdDeleteForever } from "react-icons/md";
import CloseWonModal from "./CloseWonModel.js";
import CloseLostModal from "./CloseLostModel.js";
import { saveAs } from "file-saver";
import Loader from "../../common/Loader/index.js";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { BiSolidEditAlt } from "react-icons/bi";
import { RiFilter2Fill } from "react-icons/ri";
import { notify, Toast } from "../../common/Toast/index.js";
import Model from "../../common/Model/index.js";
import formatDateIndian from "../../common/formatDateIndian.js";
import { IoPrintSharp } from "react-icons/io5";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import Filter from "../../common/Filter/index.js";

const stageMapping = {
  1: "Active",
  2: "Close Won",
  3: "Close Lost",
  6: "In-Production",
  7: "Complete",
};

const stageID = {
  Active: 1,
  "Close Won": 2,
  "Close Lost": 3,
  "In-Production": 6,
  Complete: 7,
};

const ManualQuotation = () => {
  const permission = getUserMenuPermission(9);
  const navigate = useNavigate();
  const [isManualData, setIsManualData] = useState([]);
  const [sites, setSites] = useState({});
  const [isCloseLostModalOpen, setIsCloseLostModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedCard, setSelectedCard] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openMenuCard, setOpenMenuCard] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [salePersons, setSalePersons] = useState([]);
  const filterBtnRef = useRef(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({
    quotationNo: "",
    siteName: "",
    CompanyName: "",
    salePerson: "",
  });

  const [appliedFilters, setAppliedFilters] = useState({
    quotationNo: "",
    siteName: "",
    CompanyName: "",
    salePerson: "",
  });
  const userId = sessionStorage.getItem("userId");
  const location = useLocation();
  const filteredData = location?.state?.filteredData || [];
  const isFilteredFromDashboard =
    location.state?.isFilteredFromDashboard || false;
  const [initialized, setInitialized] = useState(false);
  const [formData, setFormData] = useState({
    quotation_No: "",
    final_Amount: "",
    final_Profile_Color: "",
    glass_Color_Type: "",
    work_Complete_Date: "",
  });
  useEffect(() => {
    if (location.state?.isFilteredFromDashboard) {
      setIsManualData(
        filteredData?.quotations?.map((item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "manual-quotation",
        }))
      );
    } else {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (!initialized) {
      if (
        location.state?.isFilteredFromDashboard &&
        Array.isArray(location.state?.filteredData)
      ) {
        const transformed = filteredData?.map((item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "manual-quotation",
        }));
        setIsManualData(transformed);
        setLoading(false);
      } else {
        fetchData();
      }
      setInitialized(true);
    }
  }, [initialized, location.state]);

  const toggleMenu = (quotationNo) => {
    setOpenMenuCard((prev) => (prev === quotationNo ? null : quotationNo));
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".menu-container")) {
        setOpenMenuCard(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchSalePersons = async () => {
      try {
        const res = await axiosInstance.get("User/GetAllUser");
        const salesData = res.data.map((person) => ({
          sale_Person_Id: Number(person.sale_Person_Id),
          Sale_Person_Name: person.Sale_Person_Name,
        }));

        setSalePersons(salesData);
      } catch (error) {
        notify("Error fetching sale persons:", error);
      }
    };

    fetchSalePersons();
  }, []);

  const handleCardMove = (card, newStage, oldStageId) => {
    const currentStageID = Number(oldStageId);
    const newStageID = stageID[newStage];

    if (currentStageID === 1 && (newStageID === 2 || newStageID === 3)) {
      setSelectedCard(card);
      newStageID === 2 ? setIsModalOpen(true) : setIsCloseLostModalOpen(true);
    } else if (currentStageID === 2) {
      setSelectedCard(card);
      if (newStageID === 6) {
        handleUpdateStage(card, newStage);
      } else if (newStageID === 3) {
        setIsCloseLostModalOpen(true);
      }
    } else if (currentStageID === 6 && newStageID === 7) {
      handleUpdateStage(card, newStage);
    } else if (currentStageID === 7) {
      notify("Cannot move cards from Complete stage.");
    } else if (currentStageID === 3 && newStageID === 1) {
      handleUpdateStage(card, newStage);
    } else {
      notify(
        `Invalid move from ${stageMapping[currentStageID]} to ${stageMapping[newStageID]}`
      );
    }
  };

  const handleUpdateStage = async (card, newStage) => {
    try {
      setLoading(true);
      await axiosInstance.post("ManualQuotation/AllUpdateQuotationStage", {
        quotation_No: card,
        stage_Id: stageID[newStage],
      });
      notify("successfully updating stage:", "success");
      fetchData();
    } catch (error) {
      notify("Error updating stage:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseWonSave = async () => {
    try {
      setLoading(true);
      await axiosInstance.post("ManualQuotation/SaveCloseOwn", {
        Quotation_No: selectedCard,
        Work_Complete_Date: formData?.work_Complete_Date,
        Final_Amount: formData?.final_Amount,
        Final_Profile_Color: formData?.final_Profile_Color,
        Glass_Color_Type: formData?.glass_Color_Type,
        created_By: userId,
      });
      fetchData();
      notify("successfully Close-Won stage:", "success");
    } catch (error) {
      notify("Error saving Close Won:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseLostSave = async (reason) => {
    try {
      setLoading(true);
      await axiosInstance.post("ManualQuotation/SaveCloseLost", {
        quotation_No: selectedCard,
        Reason: reason,
      });
      fetchData();
      notify("successfully Close-Lost stage:", "success");
    } catch (error) {
      notify("Error saving Close Lost:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    "Active",
    "Close Won",
    "In-Production",
    "Complete",
    "Close Lost",
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const hasFilters = Object.values(appliedFilters).some(
        (val) => val.trim() !== ""
      );
      const [manualDataResponse, sitesResponse] = await Promise.all([
        axiosInstance.post("ManualQuotation/GetAllManualQuotations", {
          PageNumber: 1,
          PageSize: 10,
          Quotation_No: appliedFilters.quotationNo
            ? Number(appliedFilters.quotationNo)
            : null,
          Site_ID: appliedFilters.siteName
            ? Number(appliedFilters.siteName)
            : null,
          Company_Id: appliedFilters.CompanyName
            ? Number(appliedFilters.CompanyName)
            : null,
          sale_Person_Id: hasFilters
            ? appliedFilters.salePerson
              ? Number(appliedFilters.salePerson)
              : null
            : Number(userId),
        }),
        axiosInstance.get("SiteDetail/GetAll"),
      ]);

      const transformedData = manualDataResponse.data.quotations.map(
        (item) => ({
          ...item,
          column: stageMapping[item.stage_Id] || "Unknown",
          type: "manual-quotation",
        })
      );

      setIsManualData(transformedData);

      const siteMap = sitesResponse.data.reduce((acc, site) => {
        acc[site.site_Id] = site.site_Name;
        return acc;
      }, {});
      setSites(siteMap);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isFilteredFromDashboard) {
      fetchData();
    }
  }, [appliedFilters]);

  const applyFilters = () => {
    if (isFilteredFromDashboard) return;
    setAppliedFilters(filters);
    setIsFilterOpen(false);
  };

  const clearFilters = () => {
    setFilters({
      quotationNo: "",
      siteName: "",
      CompanyName: "",
      salePerson: "",
    });
    setAppliedFilters({
      quotationNo: "",
      siteName: "",
      CompanyName: "",
      salePerson: "",
    });
  };

  const handleEdit = async (quotationNo) => {
    try {
      setLoading(true);
      const { data } = await axiosInstance.get(
        `ManualQuotation/GetManualQuotationAndTerms/${quotationNo}`
      );
      notify("ManualQuotation loaded for editing.", "success");
      navigate("/quotes/manual-quotation/manual-details", {
        state: { manualDetailsData: data },
      });
      fetchData();
    } catch (error) {
      notify("Error fetching ManualQuotation details:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(
        `ManualQuotation/DeleteManualQuotationAndTerms/${selectedId}`
      );
      setAppliedFilters({ ...appliedFilters });
      notify("WindowQuotation deleted successfully!", "error");
    } catch (err) {
      notify("Error deleting error:", err);
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handlePrint = async (quotation_No) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `ManualQuotation/ManualQuotePrint/${quotation_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const currentQuotation = isManualData.find(
          (q) => q.quotation_No === quotation_No
        );

        const siteName = sites[currentQuotation?.site_Id] || "UnknownSite";
        const formattedSiteName = siteName.replace(/\s+/g, "_");

        const fileName = `Q_${quotation_No}_${formattedSiteName}.pdf`;

        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, fileName);

        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing material quotation:", error);
      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const renderCard = (card) => {
    const stageOptions = {
      1: ["Close Won", "Close Lost"],
      2: ["In-Production", "Close Lost"],
      6: ["Complete"],
      7: [],
      3: ["Active"],
    };
    const salePersonName =
      salePersons.find(
        (sp) => Number(sp.sale_Person_Id) === Number(card.sale_Person_Id)
      )?.Sale_Person_Name || "-";

    const getInitials = (name) => {
      if (!name) return "";
      const words = name.trim().split(" ");
      return words
        .slice(0, 2)
        .map((w) => w.charAt(0).toUpperCase())
        .join("");
    };
    const initials = getInitials(salePersonName);
    return (
      <>
        <div className="relative rounded-lg bg-white shadow-md p-4 border border-gray-2 mt-4 hover:shadow-lg transition duration-200 cursor-pointer ">
          <div
            key={card.quotation_No}
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData("cardId", card.quotation_No.toString());
              e.dataTransfer.setData("stageId", card.stage_Id.toString());
            }}
          >
            <div className="flex justify-between items-center ">
              <p className="text-lg font-semibold text-primary">
                # {card.quotation_No}
              </p>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMenu(card.quotation_No);
                }}
                className="text-gray-700 hover:text-black"
              >
                <HiOutlineDotsVertical className="w-5 h-5" />
              </button>
            </div>
            <div
              className={`cursor-pointer`}
              onClick={() => handleEdit(card.quotation_No)}
            >
              <p className="text-md font-semibold text-primary">
                {sites[card.site_Id] || "Site Name Not Found"}
              </p>
              <p className="text-sm font-medium">₹{card.net_Amount}</p>
              <p className="text-sm font-medium">{salePersonName}</p>
              <div className="flex items-center justify-between mt-2 border-t border-primary pt-2">
                <p className="text-sm font-medium">
                  {formatDateIndian(card.quotation_Date)}
                </p>
                <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-semibold">
                  {initials}
                </div>
              </div>
            </div>

            {openMenuCard === card.quotation_No && (
              <div className="absolute right-0 top-[22%] w-32 bg-white border shadow-md rounded-md z-9999">
                {permission.isUpdate && (
                  <button
                    onClick={() => handleEdit(card.quotation_No)}
                    className="w-full flex items-center gap-3 text-left px-4 py-2 text-gray-700 hover:bg-gray-200"
                  >
                    <BiSolidEditAlt /> Edit
                  </button>
                )}

                <button
                  onClick={() => handlePrint(card.quotation_No)}
                  className="w-full flex items-center gap-3 text-left px-4 text-gray-700 hover:bg-gray-200"
                >
                  <IoPrintSharp /> Print
                </button>
                {permission.isDelete && (
                  <button
                    // onClick={() => handleDelete(card.quotation_No)}
                    // className="w-full flex items-center gap-3 text-left px-4 py-2 text-red-600 hover:bg-gray-200"
                    onClick={() => handleDelete(card.quotation_No)}
                    className="w-full flex items-center gap-3 text-left px-4 py-2 text-danger hover:bg-gray-200"
                  >
                    <MdDeleteForever /> Delete
                  </button>
                )}
                <div className="border-b" />

                {stageOptions[card.stage_Id]?.map((option) => (
                  <button
                    key={option}
                    onClick={() =>
                      handleCardMove(card.quotation_No, option, card.stage_Id)
                    }
                    className="w-full flex items-center gap-2 text-left px-4 py-1 text-gray-700 hover:bg-gray-200"
                  >
                    {option}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </>
    );
  };
  const salePersonOptions = [
    ...salePersons.map((sp) => ({
      value: sp.sale_Person_Id.toString(),
      label: sp.Sale_Person_Name,
    })),
  ];
  const siteOptions = Object.entries(sites).map(([id, name]) => ({
    value: id,
    label: name,
  }));

  const filterFields = [
    {
      label: " Quotation No",
      name: "quotationNo",
      type: "text",
      placeholder: "Search site name",
    },
    {
      label: " Sales Person",
      name: "salePerson",
      type: "select",
      options: salePersonOptions,
    },
    {
      label: "Site Name",
      name: "siteName",
      type: "select",
      options: siteOptions,
    },
  ];
  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-9999">
            <Loader />
          </div>
        )}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          {permission.isInsert && (
            <button
              className="bg-primary rounded px-4 text-white py-2 w-full sm:w-auto"
              onClick={() =>
                navigate("/quotes/manual-quotation/manual-details")
              }
            >
              + Add New Quotation
            </button>
          )}
          <button
            className="flex items-center gap-2 bg-gray-200 px-3 py-2 rounded-md"
            ref={filterBtnRef}
            onClick={() => setIsFilterOpen((prev) => !prev)}
          >
            <RiFilter2Fill className="text-lg text-primary" />
            Filter
          </button>
        </div>

        <Filter
          isOpen={isFilterOpen}
          onClose={() => setIsFilterOpen(false)}
          filterFields={filterFields}
          filters={filters}
          setFilters={setFilters}
          applyFilters={applyFilters}
          clearFilters={clearFilters}
        />

        <div className="h-full">
          <KanbanBoard
            columns={columns}
            cards={isManualData}
            onCardMove={handleCardMove}
            renderCard={renderCard}
          />
          <CloseWonModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSave={handleCloseWonSave}
            requiresFile={false}
            formData={formData}
            setFormData={setFormData}
          />
          <CloseLostModal
            isOpen={isCloseLostModalOpen}
            onClose={() => setIsCloseLostModalOpen(false)}
            onSave={handleCloseLostSave}
          />
        </div>
      </div>
      <Model
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <div className="p-4 text-center">
          <p className="text-lg font-semibold mb-4">
            Are you sure you want to delete this site?
          </p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-gray-5 px-4 py-2 rounded-md"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="bg-danger text-white px-4 py-2 rounded-md"
              onClick={handleConfirmDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default ManualQuotation;
